import axios from "axios";
import authHeader from "./auth-header";
import apihostname from "./apihostname";

const instance = axios.create({
  baseURL: apihostname,
  headers: authHeader(),
});

// const head = { "Content-Type": "multipart/form-data" };
// const instance2 = axios.create({
//   baseURL: apihostname,
//   headers: { ...authHeader(), ...head },
// });

class AssocService {
  getAssocList() {
    return instance.get("/assoc/list");
  }
  getAssociationById(assoc_id) {
    return instance.get("/assoc/" + assoc_id);
  }
  getAllMembers(body) {
    return instance.post("/assoc/members/all", body);
  }
  getMembersByAssoc(body) {
    return instance.post("/assoc/members/", body);
  }
  createNewAssoc(body) {
    return instance.post("/assoc/create", body);
  }
  updateAssociation(body) {
    return instance.post("/assoc/update", body);
  }
  deleteAssociation(assoc_id) {
    return instance.delete("/assoc/delete/" + assoc_id);
  }
  activateAssociation(body) {
    return instance.post("/assoc/activate/", body);
  }
  // Member Manipulate
  validateNewMember(idcard, assoc_id) {
    return instance.get("/assoc/check/" + idcard + "/" + assoc_id);
  }
  createMember(body) {
    return instance.post("/assoc/member/new", body);
  }
  updateMember(body) {
    // console.log(body);
    return instance.post("/assoc/member/update", body);
  }
  deleteMember(member_id) {
    return instance.delete("/assoc/member/delete/" + member_id);
  }
  activateMember(body) {
    return instance.post("/assoc/member/activate/", body);
  }
  getMemberById(member_id) {
    return instance.get("/assoc/member/" + member_id);
  }
  getAssocSummary(body) {
    // console.log(body);
    return instance.post("/assoc/summary", body);
  }
}

export default new AssocService();
